import { render } from "./Risk Management Policy.vue?vue&type=template&id=0b950908&scoped=true"
const script = {}

import "./Risk Management Policy.vue?vue&type=style&index=0&id=0b950908&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b950908"]])

export default __exports__